/* import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable'; */
import React from 'react';
// Fuente del sistema de diseño (ver src/assets/scss/_user-variables.scss).
import '@fontsource-variable/geist';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import App from './App';
import Main from './Main';
import './helpers/initFA';
import reportWebVitals from './reportWebVitals';

if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    autocapture: true,
  });
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Network request failed',
    /^ChunkLoadError/,
  ],
});

createRoot(document.getElementById('main')).render(<Main><App/></Main>);
reportWebVitals();